import {useMutation, gql} from '@apollo/client'

export const MUTATE_UPDATE_SA_PERMISSIONS = gql`
  mutation MUTATE_UPDATE_SA_PERMISSIONS(
    $jurisdiction: [Int]
    $dataAggregation: [Int]
    $filters: [String]
    $usecase: [Int]
    $trendAnalysisFlag: [Int]
    $chatbotFlag: [Int]
    $chatbotExportFlag: [Int]
    $chatbotCopyFlag: [Int]
    $benefits: [Int]
    $workforces: [Int]
    $exportFlag: [Int]
    $pointOfInterest: [Int]
    $personaFlag: [Int]
    $userFeedbackFlag: [Int]
    $closeExistingEventFlag: Boolean
  ) {
    updateAdminPermissions(
      jurisdiction: $jurisdiction
      dataAggregation: $dataAggregation
      filters: $filters
      usecase: $usecase
      trendAnalysisFlag: $trendAnalysisFlag
      chatbotFlag: $chatbotFlag
      chatbotExportFlag: $chatbotExportFlag
      chatbotCopyFlag: $chatbotCopyFlag
      benefits: $benefits
      workforces: $workforces
      exportFlag: $exportFlag
      pointOfInterest: $pointOfInterest
      personaFlag: $personaFlag
      userfeedbackFlag: $userFeedbackFlag
      closeExistingEventFlag: $closeExistingEventFlag
    ) {
      updateAdminPermissions {
        data_aggregation
        filters
        jurisdiction
        usecase
        trend_analysis_flag
        chatbot_flag
        chatbot_export_flag
        chatbot_copy_flag
        export_flag
        benefits
        workforces
        point_of_interest
        persona_flag
        userfeedback_flag
        is_completed
      }
    }
  }
`

export function useUpdateAdminPermission() {
  return useMutation(MUTATE_UPDATE_SA_PERMISSIONS, {
    context: {clientName: 'adminPanel'}
  })
}
